import Button from '../../components/commons/button'
import icEdit04Primary from '../../assets/images/ic-edit-04-primary.svg'
import icTrash01Red from '../../assets/images/ic-trash-01-red.svg'
import { ACTION_TYPE } from '../../constants/constant'
import { formatDateMoment } from '../../utils/utils'

export const TABLE_SOP_CATEGORY = {
    name: 'SOP Category',
    column: [
        {
            name: 'Category',
            key: 'name',
            className: 'font-semibold capitalize w-full',
        },
        {
            name: 'Created Date',
            key: 'created_at',
            className: 'capitalize min-w-[200px] w-[200px]',
            render: ({ value }) => value ? formatDateMoment(value, 'DD MMM YYYY') : '-',
        },
        {
            name: 'Action',
            key: 'action',
            classNameHeader: '!text-center',
            render: ({ item, onClickItem }) => (
                <div className='flex space-x-3 justify-center'>
                    <Button
                        type='outline'
                        icon={icEdit04Primary}
                        onClick={() => onClickItem({ item, actionType: ACTION_TYPE.EDIT })}
                    />
                    <Button
                        type='danger'
                        icon={icTrash01Red}
                        onClick={() => onClickItem({ item, actionType: ACTION_TYPE.DELETE })}
                    />
                </div>
            ),
        },
    ],
}

export const INITIAL_DATA_QUERY_SOP_CATEGORY = {
    page: 1,
    limit: 20,
    search: '',
}
